enum AdminAppPaths {
  Home = '/',
  Monitoring = '/monitoring',
  NotFound = '/*',
}

export default AdminAppPaths;
